import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  FormControlLabel,
  Switch,
  // FormControl,
  InputAdornment,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormLabel,
  Card,
  CardContent,
  Grid,
  ButtonGroup,
} from "@mui/material";
import Tab from "@mui/material/Tab";
import { TabContext } from "@mui/lab";
import { toast } from "react-toastify";

import {
  Email,
  AccountCircle,
  Edit,
  Delete,
  Close,
  Add,
} from "@mui/icons-material";
import "react-quill/dist/quill.snow.css";
import EmailAppearance from "./emailappearance";
import { useTranslation } from "react-i18next";
import { MaterialReactTable, MRT_ColumnDef } from "material-react-table";
import axios from "axios";
import { axiosInstance } from "../../../utils/tokenSetCookie";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

type EmailMessage = {
  subject: string;
  message: string;
  type: string;
  id: number;
};

const DefaultMessageSetting: React.FC = () => {
  const [value, setValue] = React.useState("1");
  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const [showEmailTable, setShowEmailTable] = useState(true);
  const [showSmsTable, setShowSmsTable] = useState(false);
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogAdd, setOpenDialogAdd] = useState(false);

  const [formData, setFormData] = useState({
    subject: "",
    message: "",
    type: "",
    id: 0,
  });
  const [fromName, setFromName] = useState("");
  const [bccAddresses, setBccAddresses] = useState("");
  const [indexToUpdate, setIndexToUpdate] = useState<number | null>(null);
  const [currentLabel, setcurrentLabel] = useState<string>("Email");
  const [emailMessage, setEmailMessage] = useState<EmailMessage[]>([]);
  const [smsMessage, setSmsMessage] = useState<EmailMessage[]>([]);
  const [showSystemDefinedMessage, setShowSystemDefinedMessage] =
    useState(false);

  const maxLength = 1400;
  const emailColumns: MRT_ColumnDef<EmailMessage>[] = [
    {
      accessorKey: "subject",
      header: "Subject",
      muiTableHeadCellProps: { sx: { width: "30%" } },
    },
    {
      accessorKey: "message",
      header: "Message",
      muiTableHeadCellProps: { sx: { width: "50%" } },

      Cell: ({ cell }) => {
        const message =
          cell.getValue<string>() || "<i>No message available</i>";
        return <div dangerouslySetInnerHTML={{ __html: message }} />;
      },
    },
    {
      accessorKey: "actions",
      header: "Actions",
      muiTableHeadCellProps: { sx: { width: "20%", textAlign: "center" } },
      Cell: ({ row }) => (
        <Box>
          <IconButton
            color="primary"
            size="small"
            onClick={() => handleEditDialog(row.index, row.original)}
          >
            <Edit />
          </IconButton>
          <IconButton
            color="error"
            size="small"
            onClick={() => handleDeleteMessage(row.original)}
          >
            <Delete />
          </IconButton>
        </Box>
      ),
    },
  ];
  //temporary data
  const smsColumns: MRT_ColumnDef<EmailMessage>[] = [
    {
      accessorKey: "subject",
      header: "Title",
      muiTableHeadCellProps: { sx: { width: "30%" } },
    },
    {
      accessorKey: "message",
      header: "Message",
      muiTableHeadCellProps: { sx: { width: "50%" } },
      Cell: ({ cell }) => (
        <div dangerouslySetInnerHTML={{ __html: cell.getValue<string>() }} />
      ),
    },
    {
      accessorKey: "actions",
      header: "Actions",
      muiTableHeadCellProps: { sx: { width: "20%", textAlign: "center" } },

      Cell: ({ row }) => (
        <Box>
          <IconButton
            color="primary"
            size="small"
            onClick={() => handleEditDialog(row.index, row.original)}
          >
            <Edit />
          </IconButton>
          <IconButton
            color="error"
            size="small"
            onClick={() => handleDeleteMessage(row.original)}
          >
            <Delete />
          </IconButton>
        </Box>
      ),
    },
  ];

  const handleCheckboxChange = async () => {
    try {
      const response = await axiosInstance.put(
        `${API_BASE_URL}share-animation-settings/updateSystemDefinedMsg`
      );


      if (response.status >= 200 && response.status < 300) {
        // setShowSystemDefinedMessage(response.data.data.showSystemDefinedMessage);
        toast("Message updated successfully!");
        fetchMessageDetails();
      }
    } catch (err) {
      toast.error("Failed to fetch email details.");
    }
  };

  const handleFromNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFromName(event.target.value);
  };

  const handleBccChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBccAddresses(event.target.value);
  };

  const validateEmails = (email: string) => {
    const emailList = email.split(",").map((email) => email.trim());
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailList.every((email) => emailRegex.test(email));
  };

  const fetchEmail = async () => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}share-animation-settings/getShareMessageDetails`
      );


      if (response.status >= 200 && response.status < 300) {
        const { emailFromName, bccEmail } = response.data.data;
        setFormData(response.data.data);
        setFromName(emailFromName || "");
        setBccAddresses(bccEmail || "");
      }
    } catch (err) {
      toast.error("Failed to fetch email details.");
    }
  };

  const fetchMessageDetails = async () => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}share-animation-settings/getShareMessageDetails`
      );


      if (response.status >= 200 && response.status < 300) {
        setShowSystemDefinedMessage(
          response.data.data.showSystemDefinedMessage
        );
      }
    } catch (err) {
      toast.error("Failed to fetch email details.");
    }
  };

  const handleGenerateReport = async () => {
    try {
      // Construct query parameters dynamically
      // const params = new URLSearchParams({
      //   businessentityId: "1",
      //   classId: formData.classId?.toString() || "", // Convert to string
      //   locationId: formData.location?.toString() || "", // Convert to string
      //   dateFilterType: formData.dateFilter?.toString() || "", // Convert to string
      //   userId: formData.user?.toString() || "", // Convert to string
      // });

      // Make GET request with URL parameters
      const response = await axiosInstance.get(
        `${API_BASE_URL}share/get-email-user-templates`
      );

      // Handle successful response
      if (response.status >= 200 && response.status < 300) {
        setEmailMessage(response.data.data.email);
        setSmsMessage(response.data.data.sms);
      } else {
        console.error("API Failed:", response.status);
      }
    } catch (error) {
      console.error("Error fetching usage reports:", error);
    }
  };

  useEffect(() => {
    fetchEmail();
    handleGenerateReport();
    fetchMessageDetails();
  }, []);

  const handleSubmit = async () => {
    if (!fromName.trim()) {
      toast("Email From Name cannot be empty.");
      return;
    }
    if (!bccAddresses.trim()) {
      toast("BCC address field should not be empty");
      return;
    }
    if (bccAddresses && !validateEmails(bccAddresses)) {
      toast("Please enter valid email addresses for BCC.");
      return;
    }
    const payload = {
      fromName: fromName,
      fromBCCMail: bccAddresses,
    };
    try {
      const response = await axiosInstance.post(
        `${API_BASE_URL}share-animation-settings/updatemailsettings`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status >= 200 && response.status <= 300) {
        setFromName(response.data);
        setBccAddresses(response.data);
        fetchEmail();
        toast.success(response.data.data);
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorMessage =
          error.response?.data?.message || "Failed to update settings";
        toast.error(errorMessage);
      } else {
        toast.error("An error occurred");
      }
    }
  };

  const handleDialogSubmit = async (type: string, id: number) => {
    if (!formData.subject.trim()) {
      toast("Subject is required!");
      return;
    }
    if (!formData.message.trim()) {
      toast("Message cannot be empty!");
      return;
    }

    try {
      // Construct query parameters dynamically
      const params = {
        id: id,
        messageType: type,
        type: "update",
        subject: formData.subject,
        messageContent: formData.message,
      };

      // Make GET request with URL parameters
      const response = await axiosInstance.put(
        `${API_BASE_URL}share-animation-settings/update`,
        params
      );

      // Handle successful response
      if (response.status >= 200 && response.status < 300) {
        handleGenerateReport();
      } else {
        console.error("API Failed:", response.status);
      }
    } catch (error) {
      console.error("Error fetching usage reports:", error);
    }

    toast.success("Message added successfully!");

    handleCloseDialog();
  };

  const handleDialogSubmitAdd = async () => {
    if (!formData.subject.trim()) {
      toast("Subject is required!");
      return;
    }
    if (!formData.message.trim()) {
      toast("Message cannot be empty!");
      return;
    }

    try {
      // Construct query parameters dynamically
      const params = {
        messageType: showSmsTable ? "sms_message" : "email_message",
        subject: formData.subject,
        messageContent: formData.message,
      };

      // Make GET request with URL parameters
      const response = await axiosInstance.post(
        `${API_BASE_URL}share-animation-settings/add`,
        params
      );

      // Handle successful response
      if (response.status >= 200 && response.status < 300) {
        setOpenDialogAdd(false);
        handleGenerateReport();
      } else {
        console.error("API Failed:", response.status);
      }
    } catch (error) {
      console.error("Error fetching usage reports:", error);
    }

    toast.success("Message added successfully!");

    handleCloseDialog();
  };

  const handleToggleEmailTable = () => {
    setShowEmailTable(true);
    setShowSmsTable(false);
    setcurrentLabel("Email");

  };

  const handleToggleSmsTable = () => {
    setShowEmailTable(false);
    setShowSmsTable(true);
    setcurrentLabel("SMS");
  };

  const handleEditDialog = (index: number, msg: any) => {
    setFormData({
      subject: msg.subject,
      message: msg.message,
      type: msg.type,
      id: msg.id,
    });
    setOpenDialog(true);
    setIndexToUpdate(index);
  };
  const handleCloseDialog = () => {
    setFormData({ subject: "", message: "", type: "", id: 0 });
    setOpenDialog(false);
  };
  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const handleDeleteMessage = async (data: any) => {

    try {
      // Construct query parameters dynamically
      const params = {
        id: data.id,
        messageType: data.type,
        type: "delete",
      };

      // Make GET request with URL parameters
      const response = await axiosInstance.put(
        `${API_BASE_URL}share-animation-settings/update`,
        params
      );

      // Handle successful response
      if (response.status >= 200 && response.status < 300) {
        handleGenerateReport();
      } else {
        console.error("API Failed:", response.status);
      }
    } catch (error) {
      console.error("Error fetching usage reports:", error);
    }
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 3, md: 4 }, backgroundColor: "#f5f7fa" }}>
      <Card
        elevation={0}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          transition: "all 0.3s ease",
          overflow: "visible",
        }}
      >
        <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
          <TabContext value={value}>
            {/* Improved Tab styling */}
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
              <TabList
                onChange={handleChange}
                aria-label="settings tabs"
                sx={{
                  "& .MuiTab-root": {
                    textTransform: "none",
                    fontSize: "1rem",
                    fontWeight: 500,
                    minHeight: 48,
                    "&.Mui-selected": {
                      color: "primary.main",
                      fontWeight: 600,
                    },
                  },
                  "& .MuiTabs-indicator": {
                    height: 3,
                    borderRadius: "3px 3px 0 0",
                  },
                }}
              >
                <Tab label={t("default_message_settings")} value="1" />
                <Tab label={t("email_appearance(logo/banner)")} value="2" />
              </TabList>
            </Box>

            <TabPanel value="1" sx={{ p: 0 }}>
              <Box sx={{display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 4 }}>
                {/* Div 1 */}
                <Box>
                  {/* System Defined Messages Switch */}
                  <Card
                    elevation={0}
                    sx={{
                      mb: 4,
                      p: 2,
                      backgroundColor: "#f8f9fa",
                      borderRadius: "12px",
                      border: "1px solid rgba(0,0,0,0.1)",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Switch
                          checked={showSystemDefinedMessage}
                          onChange={handleCheckboxChange}
                          color="primary"
                        />
                      }
                      label={
                        <Typography variant="h6" sx={{ fontWeight: 500 }}>
                          {t("system_defined_messages")}
                        </Typography>
                      }
                    />
                  </Card>

                  {/* Email Settings Form */}
                  <Box sx={{ mb: 4 }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <TextField
                          label={t("email_from_name")}
                          variant="outlined"
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <AccountCircle color="primary" />
                              </InputAdornment>
                            ),
                          }}
                          value={fromName}
                          onChange={handleFromNameChange}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "12px",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label={t("bcc_address_for_sent_mail")}
                          variant="outlined"
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Email color="primary" />
                              </InputAdornment>
                            ),
                          }}
                          value={bccAddresses}
                          onChange={handleBccChange}
                          helperText="Enter multiple valid emails separated by commas"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "12px",
                            },
                          }}
                        />
                      </Grid>
                    </Grid>

                    {/* Action Buttons */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 2,
                        mt: 3,
                        mb: 4,
                      }}
                    >
                      <Button
                        variant="outlined"
                        className="cancelbtn"
                        sx={{
                          borderRadius: "10px",
                          textTransform: "none",
                          px: 4,
                        }}
                      >
                        {t("cancel")}
                      </Button>
                      <Button
                        variant="contained"
                        onClick={handleSubmit}
                        className="addbtn"
                        sx={{
                          borderRadius: "10px",
                          textTransform: "none",
                          px: 4,
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        {t("update")}
                      </Button>
                    </Box>
                  </Box>
                </Box>

                {/* Div 2 */}
                <Box sx={{flex: 1}}>
                  {/* Message Type Tabs */}
                  <Box sx={{ mb: 3 }}>
                    <ButtonGroup variant="outlined" sx={{ mb: 3 }}>
                      <Button
                        onClick={handleToggleEmailTable}
                        sx={{
                          backgroundColor: showEmailTable
                            ? "primary.main"
                            : "transparent",
                          color: showEmailTable ? "white" : "primary.main",
                          borderRadius: "10px 0 0 10px",
                          textTransform: "none",
                          px: 4,
                          "&:hover": {
                            backgroundColor: showEmailTable
                              ? "primary.dark"
                              : "rgba(25, 118, 210, 0.04)",
                          },
                        }}
                      >
                        {t("email_message")}
                      </Button>
                      <Button
                        onClick={handleToggleSmsTable}
                        sx={{
                          backgroundColor: showSmsTable
                            ? "primary.main"
                            : "transparent",
                          color: showSmsTable ? "white" : "primary.main",
                          borderRadius: "0 10px 10px 0",
                          textTransform: "none",
                          px: 4,
                          "&:hover": {
                            backgroundColor: showSmsTable
                              ? "primary.dark"
                              : "rgba(25, 118, 210, 0.04)",
                          },
                        }}
                      >
                        {t("sms_message")}
                      </Button>
                    </ButtonGroup>

                    <Button
                      variant="contained"
                      onClick={() => setOpenDialogAdd(true)}
                      startIcon={<Add />}
                      sx={{
                        float: "right",
                        borderRadius: "10px",
                        textTransform: "none",
                        px: 3,
                        mb: 2,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      }}
                    >
                      {t("add")}
                    </Button>
                  </Box>

                  {/* Tables with improved styling */}
                  <Box
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "12px",
                      boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
                      overflow: "hidden",
                    }}
                  >
                    {showEmailTable && (
                      <MaterialReactTable
                        columns={emailColumns}
                        data={emailMessage.filter(
                          (msg) => msg.type === "email_message"
                        )}
                        muiTablePaperProps={{
                          elevation: 0,
                          sx: { backgroundColor: "transparent" },
                        }}
                        muiTableHeadCellProps={{
                          sx: {
                            backgroundColor: "#f8f9fa",
                            fontWeight: 600,
                          },
                        }}
                        muiTableBodyRowProps={{
                          sx: {
                            "&:nth-of-type(odd)": {
                              backgroundColor: "#fff",
                            },
                            "&:nth-of-type(even)": {
                              backgroundColor: "#f8f9fa",
                            },
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                            },
                          },
                        }}
                      // ... other table props remain the same
                      />
                    )}

                    {/* SMS Table with similar styling */}
                    {showSmsTable && (
                      <MaterialReactTable
                        columns={smsColumns}
                        data={smsMessage.filter(
                          (msg) => msg.type === "sms_message"
                        )}
                      // ... similar styling as email table
                      />
                    )}
                  </Box>
                </Box>

              </Box>
            </TabPanel>

            <TabPanel value="2" sx={{ p: 0 }}>
              <EmailAppearance />
            </TabPanel>
          </TabContext>
        </CardContent>
      </Card>

      {/* Dialogs with improved styling */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle className="dialogtitle">
          {indexToUpdate !== null ? t("edit") : t("add")} {currentLabel}
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseDialog}
            aria-label="close"
            sx={{
              margin: "auto",
              position: "absolute",
              right: "25px",
              top: "17px",
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              border: "1px solid #be1e2d", // Red border
              color: "#be1e2d", // Default text color
              "&:hover": {
                backgroundColor: "#be1e2d", // Full red background on hover
                color: "#ffffff", // White icon color
              },
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <FormLabel
            sx={{ mt: "5px", display: "block" }}
            className="addUser_formlabel"
          >
            {t("subject")}
          </FormLabel>

          <TextField
            value={formData.subject}
            onChange={handleFormChange}
            name="subject"
            fullWidth
            margin="dense"
            variant="outlined"
          />

          <FormLabel
            sx={{ mt: "10px", display: "block" }}
            className="addUser_formlabel"
          >
            {t("message")}
          </FormLabel>

          <Box position="relative">
            <textarea
              value={formData.message}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  message: e.target.value,
                }))
              }
              maxLength={maxLength}
              rows={9}
              style={{
                width: "100%", //  Ensures full width
                padding: "10px",
                fontSize: "16px",
                borderRadius: "5px",
                resize: "none",
                border: "1px solid #ccc",
                boxSizing: "border-box",
              }}
            />

            {/* Character Counter at Bottom-Right */}
            <Typography
              variant="caption"
              sx={{
                position: "absolute",
                bottom: "8px",
                right: "10px",
                fontSize: "12px",
                color: "#000",
              }}
            >
              {formData.message?.length || 0}/{maxLength}
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ marginTop: "10px" }}>
          <Button onClick={handleCloseDialog} className="cancelbtn">
            {t("cancel")}
          </Button>

          <Button
            onClick={() => handleDialogSubmit(formData.type, formData.id)}
            variant="contained"
            color="primary"
            className="addbtn"
          >
            {indexToUpdate !== null ? t("update") : t("save")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* for Add form details */}
      <Dialog
        open={openDialogAdd}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle className="dialogtitle">
          {indexToUpdate !== null ? t("edit") : t("add")} {currentLabel}
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setOpenDialogAdd(false)}
            aria-label="close"
            sx={{
              margin: "auto",
              position: "absolute",
              right: "25px",
              top: "17px",
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              border: "1px solid #be1e2d", // Red border
              color: "#be1e2d", // Default text color
              "&:hover": {
                backgroundColor: "#be1e2d", // Full red background on hover
                color: "#ffffff", // White icon color
              },
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <FormLabel
            sx={{ mt: "5px", display: "block" }}
            className="addUser_formlabel"
          >
            {t("subject")}
          </FormLabel>

          <TextField
            value={formData.subject}
            onChange={handleFormChange}
            name="subject"
            fullWidth
            margin="dense"
            variant="outlined"
          />

          <FormLabel
            sx={{ mt: "10px", display: "block" }}
            className="addUser_formlabel"
          >
            {t("message")}
          </FormLabel>

          <Box position="relative">
            <textarea
              value={formData.message}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  message: e.target.value,
                }))
              }
              maxLength={maxLength}
              rows={9}
              style={{
                width: "100%", //  Ensures full width
                padding: "10px",
                fontSize: "16px",
                borderRadius: "5px",
                resize: "none",
                border: "1px solid #ccc",
                boxSizing: "border-box",
              }}
            />

            {/* Character Counter at Bottom-Right */}
            <Typography
              variant="caption"
              sx={{
                position: "absolute",
                bottom: "8px",
                right: "10px",
                fontSize: "12px",
                color: "#000",
              }}
            >
              {formData.message?.length || 0}/{maxLength}
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ marginTop: "10px" }}>
          <Button onClick={() => setOpenDialogAdd(false)} className="cancelbtn">
            {t("cancel")}
          </Button>

          <Button
            onClick={() => handleDialogSubmitAdd()}
            variant="contained"
            color="primary"
            className="addbtn"
          >
            {indexToUpdate !== null ? t("update") : t("save")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
export default DefaultMessageSetting;
